module.exports = __webpack_public_path__ + "static/media/formal_dining.3f55f33f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/formal_dining.png
// module id = 799
// module chunks = 0